<template>
    <div class="home">
        <div class="mainContent">
            <router-view></router-view>
        </div>
        <van-tabbar :route="true">
            <van-tabbar-item icon="location-o" name="RealTime"  to="/RealTime">站点展示</van-tabbar-item>
            <van-tabbar-item icon="search" name="History"  to="/History">数据查询</van-tabbar-item>
            <!-- <van-tabbar-item icon="chart-trending-o" name="Ekma"  to="/Ekma">EKMA</van-tabbar-item> -->
        </van-tabbar>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: 'HelloWorld',
        data () {
            return {
                mainHeight:0,
            }
        },
        methods: {
            //设置主体位置高度
            setMainContentHeight(){
                let homeHeight=$(".home").height();
                let tabbarHeight=$(".van-tabbar").height();
                $(".mainContent").height(homeHeight-tabbarHeight);
            },
        },
        mounted() {
            this.setMainContentHeight();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "style/home.css";
</style>



// WEBPACK FOOTER //
// src/Home.vue